//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ForceValidIfPaymentValid: FeatureFlag = {"Id":"ForceValidIfPaymentValid","Label":"[10.20]Force submission to be valid if payment is valid","Impact":"Allows paid submissions to continue even when validation fails while locked. Works with IgnorePaymentAmountMismatch for mismatch scenarios, and can be combined with blocking issue checks to still stop advancement on blocking issues.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
